import { createSelector } from 'reselect'
import { getPageData, getPageParams } from 'selectors/page'
import { CURATOR } from 'lib/user/constants'
import { capitalizeString } from 'lib/helpers'

export const getPageParamUserId = createSelector(
  [getPageParams],
  (pageParams): Record<string, any> => pageParams.userId || ''
)
export const getAccountData = createSelector(
  [getPageData],
  (pageData): Record<string, any> => pageData.accountData || {}
)
export const getCollectionsData = createSelector(
  [getAccountData],
  (accountData): Record<string, any> => accountData.collections || []
)
export const getCollectionsTotal = createSelector(
  [getAccountData],
  (accountData): Record<string, any> => accountData.collectionsTotal || 0
)
export const getFavoritesData = createSelector(
  [getAccountData],
  (accountData): Record<string, any> => accountData.favorites || []
)
export const getFavoritesTotal = createSelector(
  [getAccountData],
  (accountData): Record<string, any> => accountData.favoritesTotal || 0
)
export const getFullName = createSelector(
  [getAccountData],
  ({ firstName, lastName }): string => `${firstName} ${lastName}` || ''
)
export const getAccountUserID = createSelector(
  [getAccountData],
  (accountData): Record<string, any> => accountData.userId || 0
)
export const getEmail = createSelector(
  [getAccountData],
  (accountData): Record<string, any> => accountData.email || ''
)
export const getIsCuratorUserType = createSelector(
  [getAccountData],
  (accountData): boolean => accountData.userAccountType === CURATOR
)
export const getDataLayer = createSelector(
  [getAccountUserID, getFullName],
  (userId, fullName): Record<string, any> => ({
    'artist id': userId,
    'artist name': fullName,
    environment: 'production',
    pagetype: 'collectorProfile',
    subpagetype: 'profile',
  })
)
export const getMetaData = createSelector(
  [getFullName, getIsCuratorUserType],
  (fullName, isCurator): Record<string, any> => {
    const title = `${capitalizeString(fullName) || 'Collector Profile'} | Saatchi Art`
    return {
      title,
      og: {
        title,
        type: 'article',
      },
      preloadImages: [],
      robots: isCurator,
      schema: {
        webpage: {
          headline: title,
        },
      },
    }
  }
)
